import { render, staticRenderFns } from "./productFree.vue?vue&type=template&id=61fa9d14&scoped=true&"
import script from "./productFree.vue?vue&type=script&lang=js&"
export * from "./productFree.vue?vue&type=script&lang=js&"
import style0 from "./productFree.vue?vue&type=style&index=0&id=61fa9d14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa9d14",
  null
  
)

export default component.exports